import store from '../../store/store';
const cache = (action) => store.state.userData.resCache[action] ? new Date(store.state.userData.resCache[action]) : null;
/**
 * Stops disable another requests (due to computed property)
 */
let locationStop = false;
let newsStop = false;
let appointmentsStop = false;
let userStop = false;
let clienStop = false;

export default {
  getInitData: () => {
    if (cache("getInitData") < new Date()) {
      store.dispatch("getInitData");
    }
  },
  getLocations: () => {
    if (cache("updateCurrentLocations") < new Date() && !locationStop) {
      locationStop = false;
      store.dispatch("updateLocationRelated").then(() => {
        locationStop = true;
        return store.getters.getActiveLocations;
      })
    }
    return store.getters.getActiveLocations;
  },
  getAllLocations: () => {
    if (cache("updateCurrentLocations") < new Date() && !locationStop) {
      locationStop = false;
      store.dispatch("updateLocationRelated").then(() => {
        locationStop = true;
        return store.state.userData.AppActiveLocations;
      })
    }
    return store.state.userData.AppActiveLocations;
  },
  getAllNews: () => {
    if (cache("updateCurrentNews") < new Date() && !newsStop) {
      newsStop = true;
      store.dispatch("updateCurrentNews").then(() => {
        newsStop = false;
        return store.getters.getAllNews;
      })
    }
    return store.getters.getAllNews;
  },
  getUserInfo: () => {
    if (cache("updateCurrentUser") < new Date() && !userStop) {
      userStop = true;
      store.dispatch("updateCurrentUser").then(() => {
        userStop = false;
        return store.state.userData.AppActiveUser;
      })
    }
    return store.state.userData.AppActiveUser;
  },
  getUserInfoAsync: () => {
    return new Promise((resolve, reject) => {
      if (cache("updateCurrentUser") < new Date() && !userStop) {
        userStop = true;
        store.dispatch("updateCurrentUser").then(() => {
          userStop = false;
          resolve(store.state.userData.AppActiveUser);
        }).catch(err => reject(err))
      }
      resolve(store.state.userData.AppActiveUser);
    })
  },
  getActiveAppointments: () => {
    if (cache("updateCurrentAppointments") < new Date() && !appointmentsStop) {
      appointmentsStop = true;
      store.dispatch("updateCurrentAppointments").then(() => {
        appointmentsStop = false;
        return store.getters.getActiveAppointments;
      })
    }
    return store.getters.getActiveAppointments;
  },
  getAllAppointments: () => {
    if (cache("updateCurrentAppointments") < new Date() && !appointmentsStop) {
      appointmentsStop = true;
      store.dispatch("updateCurrentAppointments").then(() => {
        appointmentsStop = false;
        return store.getters.getAllAppointments;
      })
    }
    return store.getters.getAllAppointments;
  },
  getCodeListByName: codelist => {
    if (cache(`updateCurrentCodelist${codelist}`) < new Date() || !cache(`updateCurrentCodelist${codelist}`)) {

      store.dispatch(`updateCurrentCodelist`, codelist).then(() => {
        return store.state.userData.AppActiveCodelists[codelist]
      })
    }
    return store.state.userData.AppActiveCodelists[codelist]
  },
  getCodeListByNameAsync: codelist => {
    return new Promise((resolve, reject) => {
      if (cache(`updateCurrentCodelist${codelist}`) < new Date() || !cache(`updateCurrentCodelist${codelist}`)) {
        resolve(store.dispatch(`updateCurrentCodelist`, codelist).then((data) => {
          return (data)
        }))
      }
      resolve(store.state.userData.AppActiveCodelists[codelist])
    })
  },
  // helpers
  getActualClientsAsync: () => {
    return new Promise((resolve, reject) => {
      if (cache('updateCurrentClients') < new Date() || cache('updateCurrentLocations') < new Date() && !locationStop) {
        locationStop = true;
        Promise.all([store.dispatch('updateCurrentLocations'), store.dispatch('updateCurrentClients')]).then(() => {
          locationStop = false;
          resolve(store.getters.getActualClients);
        }).catch(err => reject(err))
      } else {
        resolve(store.getters.getActualClients);
      }
    })

  },
  getHcfInfo: () => {
    if (cache('updateHcfText' < new Date())) {
      store.dispatch('updateHcfText').then(() => {
        return store.getters.dashboardHcfInfo;
      })
    } else {
      return store.getters.getDashboardHcfInfo;
    }
  },
  getLocationsByCompanyId: id => {
    if (cache("updateCurrentLocations") < new Date() && !locationStop) {
      locationStop = true;
      store.dispatch("updateLocationRelated").then(() => {
        locationStop = false;
        return store.getters.getLocationsByCompanyId(id);
      })
    }
    return store.getters.getLocationsByCompanyId(id);
  },
  getClientByIdLocation: id => {
    if (cache('updateCurrentClients') < new Date()) {
      store.dispatch('updateCurrentClients').then(() => {
        return store.getters.getClientByLocationId(id);
      })
    }
    else {
      return store.getters.getClientByLocationId(id);
    }
  },
  getClientByIdLocationAsync: id => {
    return new Promise((resolve,reject) => {
      if (cache('updateCurrentClients') < new Date()) {
        store.dispatch('updateCurrentClients').then(() => {
          resolve(store.getters.getClientByLocationId(id));
        }).catch(rej => reject(rej))
      }
      else {
        return resolve(store.getters.getClientByLocationId(id));
      }
    })

  },
  getSideBarMenuLocations: () => {
    if (cache("updateCurrentLocations") < new Date() && !locationStop) {
      locationStop = true;
      store.dispatch("updateLocationRelated").then(() => {
        locationStop = false;
        return store.getters.getSideBarMenuLocations;
      })
    }
    return store.getters.getSideBarMenuLocations;

  },
  getAllLanguagesAsync: () => {
    return new Promise((resolve,reject) => {
      if(cache('updateLanguages') < new Date()){
        store.dispatch("updateLanguages").then(() => {
          resolve(store.state.userData.AppActiveLanguages);
        })
      }
      else {
        resolve(store.state.userData.AppActiveLanguages);
      }
    })
  },
  getAllCreditsAsync: () => {
    return new Promise((resolve,reject) => {
      if(cache('updateCurrentCredits') < new Date()){
        store.dispatch('updateCurrentCredits').then(() => {
          resolve(store.state.userData.AppActiveCredits);
        })
      }
      else {
        resolve(store.state.userData.AppActiveCredits);
      }
    })
  }

}
